import React from 'react';
import { Link, useLocation } from 'react-router-dom';
const Breadcrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);
  const formatPathname = name => {
    return name.charAt(0).toUpperCase() + name.slice(1).replace(/-/g, ' ');
  };
  return <div className="bg-gold-50 py-3 px-4" data-id="element-328">
      <div className="max-w-7xl mx-auto" data-id="element-329">
        <p className="text-sm" data-id="element-330">
          <Link to="/" className="text-gold-600 hover:text-gold-800" data-id="element-331">
            Home
          </Link>
          {pathnames.map((name, index) => {
          const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
          const isLast = index === pathnames.length - 1;
          return isLast ? <span key={name} className="mx-2 text-gray-600" data-id="element-332">
                <span className="mx-2" data-id="element-333">/</span>
                {formatPathname(name)}
              </span> : <span key={name} data-id="element-334">
                <span className="mx-2" data-id="element-335">/</span>
                <Link to={routeTo} className="text-gold-600 hover:text-gold-800" data-id="element-336">
                  {formatPathname(name)}
                </Link>
              </span>;
        })}
        </p>
      </div>
    </div>;
};
export default Breadcrumbs;